import React  from 'react';

import { Link, useHistory } from "react-router-dom"
import { getApiUrl } from '../../core/config/api';

const PageListItem = ({
    className = '',
    showButton = true,
    useAlternativeImage = false,
    height,
    page
}) => {
    const history = useHistory()

    const onClick = (e) => {
        e.preventDefault()
        history.push(page.url)
    }

    return (
        <div className={`page ${className}`} onClick={onClick} style={{
            cursor: 'pointer',
        }}>
            <img src={getApiUrl(`/media/${page?.image_other || page?.image}`)} style={{
              width: '100%',
              aspectRatio: '19/10',
            }} />

            { page?.tags?.length > 0 && (
                <div className="tags">
                    { page.tags.map(t => {
                        return <span key={t.name?.en}>{t.name?.en}</span>
                    })}
                </div>
            )}

            <div className="text px-3">
                <Link to={page?.url}><h3>{ page?.title }</h3></Link>

                { page?.header_text && <p>{ page?.header_text }</p>}

                {showButton && (
                    <Link to={page.url}>
                        <button className="next mt-4 mb-3">Read More</button>
                    </Link>
                )}
            </div>
        </div>
    )
}

export default PageListItem
